/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue } from '../../app.vues';
//
import retailerAuthxApi from '../../api/retailerAuthx';

import SwbComRoleBusinessSet from './ComRoleBusinessSet';
import SwbMobAppRoleSelect from './MobAppRoleSelect';
import SwbMobAppRoleResc from './MobAppRoleResc';
import SwbMerchtTplRoleRelComRole from './MerchtTplRoleRelComRole';

Vue.regist(SwbComRoleBusinessSet);
Vue.regist(SwbMobAppRoleSelect);
Vue.regist(SwbMobAppRoleResc);
Vue.regist(SwbMerchtTplRoleRelComRole);

// 职责权限关联岗位
export function openComRoleListSetDlg(params, callback) {
    let tplRoleId = params['tplRoleId'];
    //
    let theDlg = Vue.$showDialog({
        title: '职责权限 - 关联岗位',
        width: -200,
        height: -100,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-mercht-tpl-role-rel-com-role :tplRoleId="tplRoleId" ref="swb_mercht_tpl_role_rel_com_role"></swb-mercht-tpl-role-rel-com-role>' +
            '</div>',
        data: {
            tplRoleId: tplRoleId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_tpl_role_rel_com_role.getDlgResult() || {};
            if(result.type == 'info') {
                let comRoleIds = result.data || [];
                //
                callback(comRoleIds, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

export function openComRoleBusinessSetDlg(comId, roleId, roleName, readOnly, callback) {
    //
    Vue.$showDialog({
        title: '业务 - 设置',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
            '<swb-com-role-business-set :readOnly="readOnly" :comId="comId" :roleId="roleId" :roleName="roleName" ref="swb_com_role_business_set"></swb-com-role-business-set>' +
            '</div>',
        data: {
            comId: null,
            roleId: null,
            roleName: null,
            readOnly: false
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_com_role_business_set.getDlgResult() || {};
            if(result.type == 'info') {
                let itemInfo = result.data;
                //
                callback(itemInfo);
            } else {
                return false;
            }
        },
        cancelClicked: function () {
            callback();
        },
        onClosed: function () {
            callback();
        },
        lifecycle: {
            created: function () {
                this.comId = comId || null;
                this.roleId = roleId || null;
                this.roleName = roleName || null;
                this.readOnly = readOnly;
            }
        },
    });
}

//移动端（固定）角色 select
export function openMobAppRoleSelectDlg(self, roleId, mobAppRoleCode, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: '移动端（固定）角色',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        cancelText: '取消',
        template: '<div class = "">' +
            '<swb-mob-app-role-list-select :id="id" :mobAppRoleCode="mobAppRoleCode" ref="swb_mob_app_role_list_select"></swb-mob-app-role-list-select>' +
            '</div>',
        data: {
            id: roleId,
            mobAppRoleCode: mobAppRoleCode
        },
        okClicked: function () {
            let result = this.$refs.swb_mob_app_role_list_select.getDlgResult() || {};
            if(result.mobAppRoleCode == undefined || result.mobAppRoleCode == null) {
                self.$message.warning('未选择移动端角色');
                return false;
            }
            retailerAuthxApi.updateRetailerComRoleMobAppRole(result, function (result) {
                if(result.type == 'info') {
                    self.$message.success('操作成功');
                    callback();
                    theDlg.close();
                } else {
                    self.$message.warning(result.message);
                }
            });
            return false;
        },
        lifecycle: {},
    });
}

//移动端（固定）角色 关联 资源
export function openMobAppRoleRescDlg(roleId, vipLevelName, bizUnitType, readOnly, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: '移动端资源 vip级别【' + vipLevelName + '】',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: !readOnly,
        cancelText: !readOnly ? '取消' : '关闭',
        template: '<div class = "">' +
            '<swb-mob-app-role-resc :roleId="roleId" :bizUnitType="bizUnitType" :readOnly="readOnly" @handle-change="handleChange" ref="swb_mob_app_role_resc" ></swb-mob-app-role-resc>' +
            '</div>',
        data: {
            roleId: roleId,
            bizUnitType: bizUnitType,
            readOnly: readOnly
        },
        okClicked: function () {
            let selfDlg = this;
            let result = this.$refs.swb_mob_app_role_resc.getDlgResult() || {};
            if(result.type == 'info') {
                let theLoading = MsgBox.loading();
                retailerAuthxApi.saveMobAppRoleRescAndAction(result.data, function (resultData) {
                    theLoading.close();
                    if(resultData.type == 'info') {
                        // theDlg.close();
                        callback();
                        selfDlg.$message.success('保存成功');
                    } else {
                        MsgBox.warning(resultData.message);
                    }
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
            callback();
        },
        onClosed: function () {
            callback();
        },
        methods: {
            handleChange: function () {
                theDlg.close();
            },
        },
        lifecycle: {},
    });
}

import SwbComRoleMgmtArea from './ComRoleMgmtArea';

Vue.regist(SwbComRoleMgmtArea);

//移动端（固定）角色 关联 资源
export function openComRoleMgmtAreaDlg(comId, roleId, roleName, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: '管理区域 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        cancelText: '取消',
        template: '<div class = "">' +
            '<swb-com-role-mgmt-area :comId="comId" :roleId="roleId" :roleName="roleName" ref="swb_com_role_mgmt_area" ></swb-com-role-mgmt-area>' +
            '</div>',
        data: {
            roleId: roleId,
            comId: comId,
            roleName: roleName,
        },
        okClicked: function () {
            theDlg.close();
        },
        cancelClicked: function () {
            callback();
        },
        onClosed: function () {
            callback();
        },
        methods: {
            handleChange: function () {
                theDlg.close();

            },
        },
        lifecycle: {},
    });
}

import SwbComRoleSelect from './ComRoleSelect';

Vue.regist(SwbComRoleSelect);

//移动端（固定）角色 关联 资源
export function openComRoleDlg(comId, bizUnitId, bizUnitIds, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: '岗位 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        cancelText: '取消',
        template: '<div class = "">' +
            '<swb-role-list-select :comId="comId" :bizUnitId="bizUnitId" :bizUnitIds="bizUnitIds" ref="swb_role_list_select" ></swb-role-list-select>' +
            '</div>',
        data: {
            bizUnitIds: bizUnitIds,
            bizUnitId: bizUnitId,
            comId: comId,
        },
        okClicked: function () {
            let result = this.$refs.swb_role_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {},
    });
}

import SwbMerchtBizPermScopeBusinessSet from './MerchtBizPermScopeBusinessSet';

Vue.regist(SwbMerchtBizPermScopeBusinessSet);

export function openBizPermScopeDlg(id, readOnly, callbackFunc) {
    Vue.$showDialog({
        title: '业务 - 设置',
        width: 900,
        height: 700,
        showCloseBtn: false,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-mercht-biz-perm-scope-business-set :readOnly="readOnly" :roleId="roleId" ref="swb_mercht_tpl_role_business_set"></swb-mercht-biz-perm-scope-business-set>',
        data: {
            roleId: id,
            readOnly: readOnly
        },
        cancelClicked() {
            callbackFunc();
        }
    });
}

import SwbMerchtTplRoleRefList from './MerchtTplRoleRefList';

Vue.regist(SwbMerchtTplRoleRefList);

export function showPermScopRefMerchtTplRolList(row) {
    Vue.$showDialog({
        title: '查询关联的职责权限',
        width: 900,
        height: 700,
        showCloseBtn: false,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-mercht-tpl-role-ref-list :merchtBizPermScope="merchtBizPermScope" ref="swb_mercht_tpl_role_ref_list"></swb-mercht-tpl-role-ref-list>',
        data: {
            merchtBizPermScope: row,
        }
    });
}

import SwbComRoleStaffList from './ComRoleStaffList';

Vue.regist(SwbComRoleStaffList);

export function showComRoleStaffList(roleId) {
    Vue.$showDialog({
        title: '岗位人员',
        width: 600,
        height: 700,
        showCloseBtn: false,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-com-role-ref-staff-list :roleId="roleId" ref="swb_com_role_ref_staff_list"></swb-com-role-ref-staff-list>',
        data: {
            roleId: roleId,
        }
    });
}

import SwbStaffRoleListForSelect from './StaffRoleListForSelect';

Vue.regist(SwbStaffRoleListForSelect);

// 选择多商户的岗位信息
export function showStaffRoleListForSelect(params, callback) {
    let staffInfo = params['staffInfo'] || {};
    let theDlg = Vue.$showDialog({
        title: '岗位人员',
        width: 1000,
        height: 700,
        template: '<swb-retailer-staff-role-for-select :staff="staff" :checkedRoleList="[]" ref="swb_retailer_staff_role_for_select"></swb-retailer-staff-role-for-select>',
        data: {
            staff: staffInfo,
            checkedRoleList: []
        },
        okClicked: function () {
            let result = this.$refs.swb_retailer_staff_role_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/authx/selectDlg.js
// module id = 152
// module chunks = 0